module.exports = __webpack_public_path__ + "static/media/ffo_spielplatz.4639a53f.jpg";